import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("div", { class: "height10px" }, null, -1)
const _hoisted_2 = { class: "dialog-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_step = _resolveComponent("el-step")
  const _component_el_steps = _resolveComponent("el-steps")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_form = _resolveComponent("el-form")
  const _component_password_input = _resolveComponent("password-input")
  const _component_el_button = _resolveComponent("el-button")
  const _component_dialog_shell = _resolveComponent("dialog-shell")

  return (_openBlock(), _createBlock(_component_dialog_shell, {
    title: _ctx.$wordList.TabelChangePwTitle,
    footerType: "customize"
  }, {
    footer: _withCtx(() => [
      _createVNode("span", _hoisted_2, [
        _createVNode(_component_el_button, {
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('close')))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$wordList.TabelFootCancel), 1)
          ]),
          _: 1
        }),
        (_ctx.step === 0)
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 0,
              type: "primary",
              onClick: _ctx.checkOriginalPassword
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$wordList.TabelFootNext), 1)
              ]),
              _: 1
            }, 8, ["onClick"]))
          : (_ctx.step === 1)
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 1,
                type: "primary",
                onClick: _ctx.changePassword
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$wordList.TabelFootSubmit), 1)
                ]),
                _: 1
              }, 8, ["onClick"]))
            : _createCommentVNode("", true)
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_el_steps, {
        active: _ctx.step,
        "finish-status": "success"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_step, {
            title: _ctx.$wordList.TabelChangePwStepStep1
          }, null, 8, ["title"]),
          _createVNode(_component_el_step, {
            title: _ctx.$wordList.TabelChangePwStepStep2
          }, null, 8, ["title"]),
          _createVNode(_component_el_step, {
            title: _ctx.$wordList.TabelChangePwStepSuccess
          }, null, 8, ["title"])
        ]),
        _: 1
      }, 8, ["active"]),
      _hoisted_1,
      (_ctx.step === 0)
        ? (_openBlock(), _createBlock(_component_el_form, {
            key: 0,
            ref: "formOriginalRef",
            "label-position": _ctx.$formLabelPosition,
            rules: _ctx.rulesOriginal,
            model: _ctx.formOriginal
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, {
                label: _ctx.$wordList.TabelChangePwInHtmlOriginal,
                prop: "Password"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    type: "password",
                    modelValue: _ctx.formOriginal.Password,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.formOriginal.Password = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["label"])
            ]),
            _: 1
          }, 8, ["label-position", "rules", "model"]))
        : (_ctx.step === 1)
          ? (_openBlock(), _createBlock(_component_el_form, {
              key: 1,
              ref: "formRef",
              "label-position": _ctx.$formLabelPosition,
              rules: _ctx.rules,
              model: _ctx.formData
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, {
                  label: _ctx.$wordList.TabelChangePwInHtmlPassword,
                  prop: "Password"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_password_input, {
                      modelValue: _ctx.formData.Password,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.formData.Password = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode(_component_el_form_item, {
                  label: _ctx.$wordList.TabelPersonUserInHtmlConfirm,
                  prop: "Confirm"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      type: "password",
                      modelValue: _ctx.formData.Confirm,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.formData.Confirm = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["label"])
              ]),
              _: 1
            }, 8, ["label-position", "rules", "model"]))
          : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["title"]))
}